import { render, staticRenderFns } from "./benchmarks-menu.vue?vue&type=template&id=42dc1fe3&"
import script from "./benchmarks-menu.vue?vue&type=script&lang=js&"
export * from "./benchmarks-menu.vue?vue&type=script&lang=js&"
import style0 from "./benchmarks-menu.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCheckbox,VDivider,VMenu,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42dc1fe3')) {
      api.createRecord('42dc1fe3', component.options)
    } else {
      api.reload('42dc1fe3', component.options)
    }
    module.hot.accept("./benchmarks-menu.vue?vue&type=template&id=42dc1fe3&", function () {
      api.rerender('42dc1fe3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/consolidator/components/benchmarks-menu/benchmarks-menu.vue"
export default component.exports